import React, { useEffect, useState } from "react";
import Footer from "../components/common/Footer";
import NavBar from "../components/common/NavBar";
import TopImage from "../components/common/TopImage";


function SMCPage(props) {
  const [smcData, setSmcData] = useState([]);

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/smcData.json`)
      .then((res) => res.json())
      .then((data) => setSmcData(data))
      .catch((err) => console.error("Error loading SMC data:", err));
  }, []);

  const tableHeaders = { sno: "S.No.", name: "Name", designation: "Designation", residenceAddress: "Residence Address", telephone: "Telephone" };

  return (
    <div>
      <NavBar />
      <TopImage text="School Management Committee"/>

      <div className="shadow-sm  mt-20 bg-white max-w-full overflow-hidden  ">
        <div className="ml-28 max-md:mt-8 max-md:mx-5 mb-6 text-4xl font-medium tracking-wide text-black max-w-[726px] text-left">
          
        </div>

        <div className="overflow-x-auto mb-20 max-md:mb-8">
          <table className="mx-28 w-full sm:w-full max-md:w-9/12 max-md:mx-5 lg:w-10/12 xl:w-10/12 rounded-2xl border-solid border-zinc-200">
            <thead>
              {Object.keys(tableHeaders).map((key, index) => (
                <th key={index} className={`text-zinc-800 text-left text-md font-bold tracking-wide bg-blue-100 p-3 border-b-neutral-200 border-b border-solid`}>
                  {tableHeaders[key]}
                </th>
              ))}
            </thead>
            <tbody>
              {smcData.length > 0 ? (
                smcData.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td className={`justify-center px-3 py-4 text-sm sm:text-base capitalize border-b border-solid bg-zinc-50 border-b-zinc-200`}>
                      {row.sno}
                    </td>
                    <td className={`justify-center px-3 py-4 text-sm sm:text-base capitalize border-b border-solid bg-zinc-50 border-b-zinc-200`}>
                      {row.name}
                    </td>
                    <td className={`justify-center px-3 py-4 text-sm sm:text-base capitalize border-b border-solid bg-zinc-50 border-b-zinc-200`}>
                      {row.designation}
                    </td>
                    <td className={`justify-center px-3 py-4 text-sm sm:text-base capitalize border-b border-solid bg-zinc-50 border-b-zinc-200`}>
                      {row.residenceAddress}
                    </td>
                    <td className={`justify-center px-3 py-4 text-sm sm:text-base capitalize border-b border-solid bg-zinc-50 border-b-zinc-200`}>
                      {row.telephone}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="text-center px-3 py-4 text-sm sm:text-base border-b border-solid bg-zinc-50 border-b-zinc-200">
                    Loading SMC data...
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default SMCPage;
